const loadingProduct ={
    title: "Loading...",
    brand: "Loading...",
    price:{display: "₹Loading...", computable:0},
    categoryName: "Loading...",
    src:"https://res.cloudinary.com/carsmart/image/upload/v1648102604/d43c11d76c7db33af616426597e88833_onntyl.gif",
    rating:0,
    specs:{
      mileage:"Loading...",
      engine:"Loading...",
      BHP:0,
      transmission:"Loading...",
      seats:0,
      serviceCost:"₹ 0/yr"
    }
  }

  export default loadingProduct;